// SectionTabs.tsx
'use client';

import React from 'react';
import * as S from './SectionTabs.styles';

interface SectionTab {
  name: string;
  key: string;
}

interface SectionTabsProps {
  tabs: SectionTab[];
  activeTab: string;
  onTabClick: (key: string) => void;
}

const SectionTabs: React.FC<SectionTabsProps> = ({ tabs, activeTab, onTabClick }) => {
  return (
    <>
      {tabs.map((tab) => (
        <S.Button key={tab.key} active={tab.key === activeTab} onClick={() => onTabClick(tab.key)}>
          {tab.name}
        </S.Button>
      ))}
    </>
  );
};

export default SectionTabs;
